module.exports = __webpack_public_path__ + "img/solution-hmi-system-pic.b5124fe2.png";